import React , { useState } from 'react';
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import img from '../assets/images/items/group-ntf-02.png'

import data from '../assets/fake-data/data-blog2'
import Action from '../components/layouts/Action';

const BlogGrid = () => {

    const [visible , setVisible] = useState(9);
    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 3);
    }

    return (
        <div className='video'>
            <Header />
            <section className="tf-section page-title">
                <div className="container">
                    <div className="col-md-12">
                        <div className="page-title__body video">
                            <div className="block-text pt-12">
                                <h2 className="sub-title mb-20">Video Production</h2>
                                <p className="fs-24 mb-33" >Technical mastery meets creative vision.  <br />From pre-production and planning, <br />to post-production polish and delivery</p>
                            </div>
                            <img className="s2" src={img} alt="Video production services from pre-production planning to final editing delivering polished content" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="video-grid">
                <div className="container">
                    <div className="row">
                        {
                            data.slice(0,visible).map((data,index) => (
                                <div key={index} className="col-xl-4 col-md-6 col-12 fl-item2">
                                    <div className="blog-box">
                                        <div className="blog-img">
                                            {data.mediaType === 'video' ? (
                                                <div style={{padding: '56.25% 0 0 0', position: 'relative'}}>
                                                    <iframe 
                                                        src={data.videoEmbed}
                                                        title={data.title}
                                                        frameBorder="0"
                                                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen
                                                        style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                                                    ></iframe>
                                                </div>
                                            ) : (
                                                <Link to="/blog-single">
                                                    <img src={data.img} alt={`${data.title} video thumbnail`} />
                                                </Link>
                                            )}
                                        </div>
                                        <div className="blog-content">
                                            <ul className="meta"><li><Link to="/blog-single"><i className="fa fa-folder-open"></i>{data.category}</Link></li></ul>
                                            <Link to="/blog-single" className="title h6">{data.title}</Link>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        {
                        visible < data.length && 
                        <div className="col-12">
                            <div className="load-more center">
                                <Link id="loadmore" className="btn-action" to="#" onClick={showMoreItems}>
                                    Load More
                                </Link>
                            </div>
                        </div>
                        }
                        
                        
                    </div>
                </div>
            </section>

            <Action />
            <Footer />
        </div>
    );
}

export default BlogGrid;